import React from "react";
import 'bootstrap/dist/css/bootstrap.css';
import '../style/RateEdge.css';

function RateEdge ({ rateRequest, veryGoodRate, goodRate, badRate, veryBadRate, edgeRate}) {

    let txt_clr = '';
    if (edgeRate === 'very good') {
       txt_clr = 'vg-txt'; 
    }
    else if (edgeRate === 'good') {
        txt_clr = 'g-txt';
    }
    else if (edgeRate === 'bad') {
        txt_clr = 'b-txt';
    }
    else {
        txt_clr = 'vb-txt';
    }


    return (
        <>
            <div className="modal fade" id="rateModal" tabIndex="-1" aria-labelledby="rateModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="rateModalLabel">Rate the edge plausibility</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body modal-rate">
                            <div className="rate-face">
                                <button className="rate-btn verygood" onClick={veryGoodRate}>&#128512;</button>
                                <button className="rate-btn good" onClick={goodRate}>&#128578;</button>
                                <button className="rate-btn bad" onClick={badRate}>&#128577;</button>
                                <button className="rate-btn verybad" onClick={veryBadRate}>&#128553;</button>
                            </div>
                            {/* {edgeRate !== '' ? <p className={`text-${txt_clr}`}> Do you want to rate this edge as <strong>{edgeRate}</strong>?</p> : <></>} */}
                            {edgeRate !== '' ? <p className={txt_clr}> Do you want to rate this edge as <strong>{edgeRate}</strong>?</p> : <></>}
                        </div>
                        
                        { edgeRate !== '' ?
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-success" data-bs-dismiss="modal" onClick={rateRequest} >Save</button>
                            </div>
                            : <></>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default RateEdge;